import React from "react"; 

const News = () => {
    return(
        <>
            <marquee scrollamount="2" scrolldelay="30" direction="up" align="left" onmouseover="stop();" onmouseout="start();" >       
                <div class='news-area'>
                    <p className='newshead'>Change Vacancy Admission Notice For 2024-25
                        <a href="#" target='_blank'> 
                            <i class="bi bi-paperclip"></i>
                        </a>
                    </p>  
                </div>
                <div class='news-area'>
                    <p className='newshead'>Change Vacancy Admission Notice For 2024-25 
                        <a href="#" target='_blank'>  
                            <i class="bi bi-paperclip"></i>
                        </a>
                    </p>
                       
                </div>
                <div class='news-area'>
                    <p className='newshead'>Change Vacancy Admission Notice For 2024-25
                        <a href="#" target='_blank'> 
                            <i class="bi bi-paperclip"></i>
                        </a>
                    </p>    
                </div>
            </marquee>
        </>
    )
}
export default News